import { FC, useCallback, useEffect, useState } from "react";
import { LongTextSchemaItem, RowWithEmbeddedMetadata } from "@data-root/types";
import { inputGuard } from "../../hocs/guard";
import { SchemaItemProps, View, useField } from "@data-root/react";
import { aiGuard } from "../../hocs/ai";
import { Typography, Input, Skeleton } from "antd";
import { Remarks } from "../remarks";

const { Title } = Typography;

export const LongTextInput: FC<SchemaItemProps<LongTextSchemaItem>> = aiGuard(
  inputGuard(({ item }) => {
    const {
      loaded,
      displayName,
      placeholder,
      editable,
      show,
      defaultValue,
      subscribe,
      setValue: _setValue,
      value: _value,
      remarks,
    } = useField<string>(item);

    const [value, setValue] = useState<string | null>(defaultValue);
    // const [innerLoaded, setInnerLoaded] = useState<boolean>(false);

    const handleSetValue = useCallback(
      (value: string | null) => {
        if (value === null) {
          setValue("");
          _setValue("", "");
          return;
        }

        setValue(value);
        _setValue(value, value);
      },

      [_setValue]
    );

    const onChange = useCallback<React.ChangeEventHandler<HTMLTextAreaElement>>(
      (event) => {
        handleSetValue(event.target.value);
      },
      [handleSetValue]
    );

    useEffect(() => {
      const callback = (
        next: RowWithEmbeddedMetadata,
        options?: {
          init?: boolean;
          evaluation?: boolean;
        }
      ) => {
        if (options?.init) {
          setValue(next[item.id] as string);
          return;
        }
        if (!options?.evaluation) return;

        setValue(next[item.id] as string);
      };

      const unsubscribe = subscribe(callback);

      return () => {
        unsubscribe();
      };
    }, [item.id, subscribe]);

    // useEffect(() => {
    //   if (_value && !innerLoaded && loaded) {
    //     handleSetValue(_value);
    //     _setValue(value, value);
    //     setInnerLoaded(true);
    //   }
    //   return () => {
    //     console.log(value);
    //     _setValue(value, value);
    //   };
    // }, [_value, value, loaded]);

    if (!show) return null;

    return (
      <View style={{ width: "100%" }}>
        <Title level={5}>{displayName}</Title>

        {loaded ? (
          <Input.TextArea
            readOnly={!editable}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={style}
          />
        ) : (
          <Skeleton.Input block active />
        )}

        <Remarks texts={remarks} />
      </View>
    );
  })
);

const style: React.CSSProperties = {
  resize: "vertical",
  minHeight: 500,
};
